exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#accordion{overflow-x: hidden;}\n.side-nav .under-sub-menu-hold .panel-body{display: inline-block;}\n.menuHold1 .under-sub-menu-hold .card .sub_menu_acc .ul-hold.collapse{padding-left: 15px;padding-right:15px ;}\n.side-nav .searchtemplatehld .ul-hold .panel-body-bg {\n    background: #0d6ccd;\n}\n", ""]);

// exports
